import React, { Component } from 'react'
import { compose } from 'react-apollo'

import PropTypes from 'prop-types'

import enhanceWithClickOutside from 'react-click-outside'

class EventTitle extends Component {
  static propTypes = {
    value: PropTypes.string,
    onKeyUp: PropTypes.func,
    onChange: PropTypes.func,
    inputRef: PropTypes.func
  }

  static defaultProps = {
    value: ''
  }

  handleClickOutside () {
    this.props.onClickOutside()
  }

  render () {
    const { value, onKeyUp, onChange, inputRef } = this.props

    return (
      <input type="text"
             value={value}
             ref={inputRef}
             onKeyUp={e => onKeyUp(e)}
             onChange={e => onChange(e.target.value)}
             className="plan-part__title-input" />
    )
  }
}

export default compose(
  enhanceWithClickOutside
)(EventTitle)



// WEBPACK FOOTER //
// src/components/TripPlanner/InputWithOutsideClick.js